import controller from './kform-form.controller';
import template from './kform-form.html';

const kformFormDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace:  true,
	scope:    {
		disableComponents: '=?',
		form:              '=',
		formId:            '@?id',
		hideComponents:    '=?',
		name:              '=?',
		options:           '<',
		requireComponents: '=?',
	},
	controller,
	template,
});

export default kformFormDirective;
